import { createFileRoute } from '@tanstack/react-router'
import { MedicalPage, type MedicalSearch } from '~/features/medical/MedicalPage'
import { injuryQuery, loaderScope, overviewQuery } from '~/features/medical/queries'

const TABS = ['abwesenheiten', 'verlauf'] as const

export const Route = createFileRoute('/_app/kader/medizin')({
  validateSearch: (s: Record<string, unknown>): MedicalSearch => ({
    ...(TABS.includes(s.tab as (typeof TABS)[number]) ? { tab: s.tab as (typeof TABS)[number] } : {}),
    ...(typeof s.verletzung === 'string' && /^[0-9a-f-]{36}$/i.test(s.verletzung) ? { verletzung: s.verletzung } : {}),
  }),
  loaderDeps: ({ search }) => ({ verletzung: search.verletzung }),
  loader: async ({ context, deps }) => {
    const scope = await loaderScope(context.queryClient)
    const session = context.queryClient.getQueryData<{ active?: { permissions: string[] } | null }>(['session'])
    if (!scope?.teamId || !session?.active?.permissions.includes('medical.read')) return
    await Promise.all([
      context.queryClient.ensureQueryData(overviewQuery(scope.teamId, scope.season)),
      deps.verletzung ? context.queryClient.ensureQueryData(injuryQuery(deps.verletzung)).catch(() => undefined) : undefined,
    ])
  },
  component: function Medizin() {
    return <MedicalPage search={Route.useSearch()} />
  },
})
